var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.email)?_c('PortalAuthRequestCode',{attrs:{"requestCodeText":_vm.requestCodeText},on:{"email-submitted":_vm.handleEmailSubmitted}}):_c('PortalAuthEnterCode',{attrs:{"email":_vm.email,"isCodeWrong":_vm.codeExchangeFailed},on:{"code-submitted":_vm.handleCodeSubmitted}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }